import { FC, ReactNode } from 'react';
import ClassNames from 'classnames';

import styles from './Section.module.scss';

interface ISection {
  children?: ReactNode;
  margin?: string;
  padding?: string;
  className?: string;
}

const Section: FC<ISection> = ({ children, margin, padding, className }) => {
  return (
    <section className={ClassNames(styles.Section, className)} style={{ margin, padding }}>
      {children}
    </section>
  );
};

export default Section;
